export class Oauth {
  constructor(instance) {
    this.instance = instance;
  }

  /** Dados que a tela de consentimento exibe. Rota pública: sem token. */
  obterSolicitacao(requestId) {
    return this.instance.get(`/oauth/authorize/${requestId}`);
  }

  /** Exige sessão válida; devolve { redirectTo } para voltar ao aplicativo. */
  decidir(requestId, aprovar) {
    return this.instance.post(`/oauth/authorize/${requestId}/decision`, {
      aprovar,
    });
  }
}

export default (...params) => new Oauth(...params);
